import { render, staticRenderFns } from "./TableClientsTr.vue?vue&type=template&id=145efc99&scoped=true"
import script from "./TableClientsTr.vue?vue&type=script&lang=js"
export * from "./TableClientsTr.vue?vue&type=script&lang=js"
import style0 from "./TableClientsTr.vue?vue&type=style&index=0&id=145efc99&prod&lang=scss&scoped=true"
import style1 from "./TableClientsTr.vue?vue&type=style&index=1&id=145efc99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145efc99",
  null
  
)

export default component.exports